 
import { Grid } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import {
  BasicModal,
  DatePicker,
} from '@HomaHealth/ui-component-library/lib/_AIQ-components';
import { observer } from 'mobx-react';
import React from 'react';
import ReportCreateNewLabelField from '../../atoms/ReportCreateNewLabelField';
import Dropdown from '@HomaHealth/ui-component-library/lib/_AIQ-components/atoms/Dropdown';
import { commonDropDownProps } from '../../atoms/ReportsCohortItem';
import { ContractOption } from '../../../pages/AnnualRenewalProcess';

interface PopUpProps {
  open: boolean;
   
  onClose?: (open: boolean) => void;
  onCancel?: () => void;
  onConfirm?: () => void;
  vendorTypes?: string[];
  currentAgreementTypes?: string[];
  selectedVendorType?: string;
   
  setSelectedVendorType?: (value: string) => void;
   
  setSelectedCurrentAgreement?: (value: string) => void;
  selectedCurrentAgreement?: string;
  renewalDate: string;
   
  setRenewalDate: (value: string) => void;
  expectedReleaseDate: string;
   
  setExpectedReleaseDate: (value: string) => void;
  currentAgreementOptions?: ContractOption[];
  selectedContractId?: string;
  setSelectedContractId?: (value: string) => void;
  isAgreementDisabled?: boolean;
}
const useStyles = makeStyles()({
  itemsContainer: {
    display: 'flex',
    gap: '10px',
  },
  mainContainer: {
    backgroundColor: '#FAFAFC',
    padding: '20px',
    borderRadius: '8px',
  },
});

const PopUpAddNewAgreement: React.FC<PopUpProps> = observer(
  ({
    open,
    onClose,
    onCancel,
    onConfirm,
    vendorTypes,
    selectedVendorType,
    setSelectedVendorType,
    renewalDate,
    setRenewalDate,
    expectedReleaseDate,
    setExpectedReleaseDate,
    currentAgreementOptions,
    selectedContractId,
    setSelectedContractId,
    isAgreementDisabled = false,
  }) => {
    const { classes } = useStyles();
    const handleClose = () => onClose?.(false);
    const modalTitle = isAgreementDisabled
      ? 'Edit Agreement Type'
      : 'Add New Agreement Type';

    return (
      <BasicModal
        title={modalTitle}
        open={open}
        body={
          <Grid className={classes.mainContainer}>
            <Grid className={classes.itemsContainer}>
              <ReportCreateNewLabelField
                label={'Agreement Type'}
                component={
                  <Dropdown
                    label="Select Vendor Type"
                    dropDownOptions={vendorTypes ?? []}
                    dropDownValues={vendorTypes ?? []}
                    value={selectedVendorType ?? ''}
                    handleChange={(e) =>
                      setSelectedVendorType?.(e.target.value as string)
                    }
                    style={{
                      width: '386px',
                    }}
                    selectStyles={{
                      ...commonDropDownProps.selectStyles,
                      width: '386px',
                    }}
                    labelTop="10px"
                    disabled={isAgreementDisabled}
                  />
                }
              />
              <ReportCreateNewLabelField
                label={'Current Agreement'}
                component={
                  <Dropdown
                    label="Select Current Agreement"
                    dropDownOptions={
                      currentAgreementOptions?.map((opt) => opt.label) ?? []
                    }
                    dropDownValues={
                      currentAgreementOptions?.map((opt) => opt.value) ?? []
                    }
                    value={selectedContractId ?? ''}
                    handleChange={(e) =>
                      setSelectedContractId?.(e.target.value as string)
                    }
                    style={{ width: '386px' }}
                    selectStyles={{
                      ...commonDropDownProps.selectStyles,
                      width: '386px',
                    }}
                    labelTop="10px"
                  />
                }
              />
            </Grid>
            <Grid className={classes.itemsContainer}>
              <ReportCreateNewLabelField
                label={'Renewal Date'}
                component={
                  <>
                    <DatePicker
                      selectedDate={renewalDate}
                      handleChange={(_, value) => setRenewalDate(value || '')}
                      placeholder="DD/MM/YYYY"
                      width="386px"
                      height="44px"
                      format="dd/MM/yyyy"
                      minDate={undefined}
                      maxDate={undefined}
                      readOnly
                    />
                  </>
                }
              />
              <ReportCreateNewLabelField
                label={'Expected Release Date'}
                component={
                  <>
                    <DatePicker
                      selectedDate={expectedReleaseDate}
                      handleChange={(_, value) =>
                        setExpectedReleaseDate(value || '')
                      }
                      placeholder="DD/MM/YYYY"
                      width="386px"
                      height="44px"
                      format="dd/MM/yyyy"
                      minDate={undefined}
                      maxDate={undefined}
                      readOnly
                    />
                  </>
                }
              />
            </Grid>
          </Grid>
        }
        rootStyles={{
          width: '858px',
        }}
        cancelButtonLabel="Cancel"
        isConfirmDisabled={
          !selectedVendorType || !selectedContractId || !renewalDate
        }
        confirmButtonLabel="Save"
        handleCancel={onCancel ?? handleClose}
        handleConfirm={
          onConfirm ??
          (() => {
            handleClose();
          })
        }
        handleClose={handleClose}
      />
    );
  },
);

export default PopUpAddNewAgreement;
